var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid demand-detail-edit-page" },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("div", { staticClass: "demand-edit-wrap" }, [
                  !_vm.is_editing
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "edit",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: "/manager/recruitment/personalapplication",
                                })
                              },
                            },
                          },
                          [
                            _c("eva-icon", {
                              attrs: { name: "arrow-back-outline" },
                            }),
                            _vm._v(" 返回 "),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "edit",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.editDetail = _vm.is_editing = true
                              },
                            },
                          },
                          [
                            _c("eva-icon", { attrs: { name: "edit-outline" } }),
                            _vm._v(" 編輯 "),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.is_editing
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "cancel",
                            attrs: { type: "button" },
                            on: { click: _vm.cancelEditDemand },
                          },
                          [
                            _c("eva-icon", {
                              attrs: { name: "close-outline" },
                            }),
                            _vm._v(" 取消 "),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "save",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.saveDemand)
                              },
                            },
                          },
                          [
                            _c("eva-icon", { attrs: { name: "save-outline" } }),
                            _vm._v(" 儲存 "),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("form", { staticClass: "demand-form" }, [
                  _c("div", { staticClass: "tab-content" }, [
                    _c("div", { staticClass: "tab-name" }, [
                      _c("div", { staticClass: "name-inner" }, [
                        _vm._v("需求單"),
                      ]),
                    ]),
                    _c("table", { staticClass: "table table-bordered" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "width-15 text-right",
                              attrs: { id: "no" },
                            },
                            [_c("span", [_vm._v("單號")])]
                          ),
                          _c("td", { staticClass: "width-35" }, [
                            _vm._v(" " + _vm._s(_vm.demandDetail.No) + " "),
                          ]),
                          _c("td", { staticClass: "width-15 text-right" }, [
                            _c("span", [_vm._v("狀態")]),
                          ]),
                          _c("td", { staticClass: "width-35" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$common.manpowerDemandStatusFormatter(
                                    _vm.demandDetail.ManpowerDemandStatus
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("名稱")])]
                          ),
                          _vm.is_editing
                            ? _c(
                                "td",
                                { attrs: { colspan: "3" } },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.demandDetail
                                                        .ManpowerDemandName,
                                                    expression:
                                                      "demandDetail.ManpowerDemandName",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  maxlength: "50",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.demandDetail
                                                      .ManpowerDemandName,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "ManpowerDemandName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _c("td", { attrs: { colspan: "3" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.demandDetail.ManpowerDemandName
                                    ) +
                                    " "
                                ),
                              ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("申請時間")]),
                          ]),
                          _c("td", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$common.dateFormatter(
                                    _vm.demandDetail.ApplicantTime
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("申請者")]),
                          ]),
                          _c("td", [
                            _vm._v(
                              " " + _vm._s(_vm.demandDetail.Applicant) + " "
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("申請部門")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.demandDetail.DemandDepartment) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("履歷類型")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.demandDetail.ResumeType,
                                        expression: "demandDetail.ResumeType",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.demandDetail,
                                          "ResumeType",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: { disabled: "" },
                                        domProps: { value: null },
                                      },
                                      [_vm._v("請選擇")]
                                    ),
                                    _vm._l(
                                      _vm.resumeTypeLIst,
                                      function (resume) {
                                        return _c(
                                          "option",
                                          {
                                            key: resume.Type,
                                            domProps: { value: resume.Type },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(resume.Name) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.demandDetail.ResumeType) +
                                      " "
                                  ),
                                ]),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("招募期限")]),
                          ]),
                          _vm.is_editing
                            ? _c(
                                "td",
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      tag: "section",
                                      name: "招募期限",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("date-picker", {
                                                staticClass: "w-100",
                                                attrs: {
                                                  format: "YYYY-MM-DD",
                                                  valueType: "format",
                                                  "disabled-date":
                                                    _vm.$common
                                                      .disabledDateBeforeToday,
                                                },
                                                model: {
                                                  value:
                                                    _vm.demandDetail
                                                      .RecruitmentDeadline,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "RecruitmentDeadline",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "demandDetail.RecruitmentDeadline",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$common.dateFormatter(
                                        _vm.demandDetail.RecruitmentDeadline
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("聘僱合約類別")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail.ContractType,
                                                expression:
                                                  "demandDetail.ContractType",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "一般",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.ContractType,
                                                "一般"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "ContractType",
                                                  "一般"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 一般 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail.ContractType,
                                                expression:
                                                  "demandDetail.ContractType",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "競業禁止",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.ContractType,
                                                "競業禁止"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "ContractType",
                                                  "競業禁止"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 競業禁止 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail.ContractType,
                                                expression:
                                                  "demandDetail.ContractType",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "鐘點計時",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.ContractType,
                                                "鐘點計時"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "ContractType",
                                                  "鐘點計時"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 鐘點計時 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail.ContractType,
                                                expression:
                                                  "demandDetail.ContractType",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "定期合約",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.ContractType,
                                                "定期合約"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "ContractType",
                                                  "定期合約"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 定期合約 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.demandDetail.ContractType) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_vm._v("招募方式")]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    _vm._l(
                                      _vm.recruitmentMethod,
                                      function (item) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.RecruitmentMethodGuid,
                                            staticClass:
                                              "form-check form-check-inline",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form-check-label",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.demandDetail
                                                          .ManpowerDemandRecruitmentMethod,
                                                      expression:
                                                        "\n                            demandDetail.ManpowerDemandRecruitmentMethod\n                          ",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: item,
                                                    checked: Array.isArray(
                                                      _vm.demandDetail
                                                        .ManpowerDemandRecruitmentMethod
                                                    )
                                                      ? _vm._i(
                                                          _vm.demandDetail
                                                            .ManpowerDemandRecruitmentMethod,
                                                          item
                                                        ) > -1
                                                      : _vm.demandDetail
                                                          .ManpowerDemandRecruitmentMethod,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.demandDetail
                                                            .ManpowerDemandRecruitmentMethod,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = item,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.demandDetail,
                                                              "ManpowerDemandRecruitmentMethod",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.demandDetail,
                                                              "ManpowerDemandRecruitmentMethod",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.demandDetail,
                                                          "ManpowerDemandRecruitmentMethod",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.RecruitmentMethod
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _c("div", { staticClass: "form-group" }, [
                                    _vm.recruitmentMethodOtherStatus
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                            },
                                          },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("textarea", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.recruitmentMethodDescription,
                                                              expression:
                                                                "recruitmentMethodDescription",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            maxlength: "100",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.recruitmentMethodDescription,
                                                          },
                                                          on: {
                                                            compositionstart:
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.is_composing = true
                                                              },
                                                            compositionend:
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.is_composing = false
                                                              },
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.recruitmentMethodDescription =
                                                                $event.target.value
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        errors[0] &&
                                                        !_vm.is_composing
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _vm.recruitmentMethodStatus
                                      ? _c("span", [_vm._v("不拘")])
                                      : _vm._l(
                                          _vm.showRecruitmentMethod,
                                          function (item) {
                                            return _c(
                                              "span",
                                              {
                                                key: item.RecruitmentMethodGuid,
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.RecruitmentMethodDescription
                                                      ? `其他：${item.RecruitmentMethodDescription}`
                                                      : item.RecruitmentMethod
                                                  )
                                                ),
                                                _c("br"),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("職務性質")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .PositionProperty,
                                                expression:
                                                  "demandDetail.PositionProperty",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "全職",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail
                                                  .PositionProperty,
                                                "全職"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "PositionProperty",
                                                  "全職"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 全職 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .PositionProperty,
                                                expression:
                                                  "demandDetail.PositionProperty",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "兼職",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail
                                                  .PositionProperty,
                                                "兼職"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "PositionProperty",
                                                  "兼職"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 兼職 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .PositionProperty,
                                                expression:
                                                  "demandDetail.PositionProperty",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "高階",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail
                                                  .PositionProperty,
                                                "高階"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "PositionProperty",
                                                  "高階"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 高階 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.demandDetail.PositionProperty
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                            ]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: _vm.i18n("Position.PositionName"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("v-select", {
                                                  attrs: {
                                                    options: _vm.positionList,
                                                    label: "PositionName",
                                                  },
                                                  model: {
                                                    value: _vm.positionValue,
                                                    callback: function ($$v) {
                                                      _vm.positionValue = $$v
                                                    },
                                                    expression: "positionValue",
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.demandDetail.PositionName) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("需求人數")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "min_value:1|required|",
                                        name: "需求人數",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value:
                                                        _vm.demandDetail
                                                          .DemandNumber,
                                                      expression:
                                                        "demandDetail.DemandNumber",
                                                      modifiers: {
                                                        number: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.demandDetail
                                                        .DemandNumber,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "DemandNumber",
                                                        _vm._n(
                                                          $event.target.value
                                                        )
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.demandDetail.DemandNumber) +
                                      " 人"
                                  ),
                                ]),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("預定任職日")]),
                          ]),
                          _vm.is_editing
                            ? _c(
                                "td",
                                [
                                  _c("date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "disabled-date":
                                        _vm.$common.disabledDateBeforeToday,
                                      format: "YYYY-MM-DD",
                                      valueType: "format",
                                    },
                                    model: {
                                      value: _vm.demandDetail.OnBoard,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.demandDetail,
                                          "OnBoard",
                                          $$v
                                        )
                                      },
                                      expression: "demandDetail.OnBoard",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("td", [
                                _vm.demandDetail.OnBoard
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$common.dateFormatter(
                                              _vm.demandDetail.OnBoard
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("div", [_vm._v("不拘")]),
                              ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("年齡")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .AgeRangeWhatever,
                                                expression:
                                                  "demandDetail.AgeRangeWhatever",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.demandDetail
                                                  .AgeRangeWhatever
                                              )
                                                ? _vm._i(
                                                    _vm.demandDetail
                                                      .AgeRangeWhatever,
                                                    null
                                                  ) > -1
                                                : _vm.demandDetail
                                                    .AgeRangeWhatever,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.demandDetail
                                                      .AgeRangeWhatever,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "AgeRangeWhatever",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "AgeRangeWhatever",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.demandDetail,
                                                    "AgeRangeWhatever",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" 不拘 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  !_vm.demandDetail.AgeRangeWhatever
                                    ? _c("div", { staticClass: "form-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                tag: "section",
                                                name: "年齡",
                                                rules:
                                                  "min_value:18|max_value:80|required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.demandDetail
                                                                  .AgeRangeStart,
                                                              expression:
                                                                "demandDetail.AgeRangeStart",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "number",
                                                            min: "18",
                                                            max: "80",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.demandDetail
                                                                .AgeRangeStart,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                _vm.demandDetail,
                                                                "AgeRangeStart",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" ~ "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                tag: "section",
                                                name: "年齡",
                                                rules:
                                                  "min_value:18|max_value:80|required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                _vm.demandDetail
                                                                  .AgeRangeEnd,
                                                              expression:
                                                                "demandDetail.AgeRangeEnd",
                                                              modifiers: {
                                                                number: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "number",
                                                            min: "18",
                                                            max: "80",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.demandDetail
                                                                .AgeRangeEnd,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                _vm.demandDetail,
                                                                "AgeRangeEnd",
                                                                _vm._n(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  _vm.demandDetail.AgeRangeWhatever
                                    ? _c("div", [_vm._v("不拘")])
                                    : _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.demandDetail.AgeRangeStart
                                            ) +
                                            "～" +
                                            _vm._s(
                                              _vm.demandDetail.AgeRangeEnd
                                            ) +
                                            " "
                                        ),
                                      ]),
                                ]),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("性別")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.demandDetail.Sex,
                                                expression: "demandDetail.Sex",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "不拘",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.Sex,
                                                "不拘"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "Sex",
                                                  "不拘"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 不拘 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.demandDetail.Sex,
                                                expression: "demandDetail.Sex",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "男",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.Sex,
                                                "男"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "Sex",
                                                  "男"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 男 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.demandDetail.Sex,
                                                expression: "demandDetail.Sex",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              type: "radio",
                                              value: "女",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.demandDetail.Sex,
                                                "女"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.demandDetail,
                                                  "Sex",
                                                  "女"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" 女 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(_vm.demandDetail.Sex) + " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("出差")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-check form-check-inline",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.demandDetail.BusinessTrip,
                                              expression:
                                                "demandDetail.BusinessTrip",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.demandDetail.BusinessTrip
                                            )
                                              ? _vm._i(
                                                  _vm.demandDetail.BusinessTrip,
                                                  null
                                                ) > -1
                                              : _vm.demandDetail.BusinessTrip,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.demandDetail.BusinessTrip,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "BusinessTrip",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "BusinessTrip",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "BusinessTrip",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" 需要 "),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        !_vm.demandDetail.BusinessTrip
                                          ? "否"
                                          : "是"
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("外派")]),
                          ]),
                          _c("td", [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-check form-check-inline",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.demandDetail.OverseasWork,
                                              expression:
                                                "demandDetail.OverseasWork",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.demandDetail.OverseasWork
                                            )
                                              ? _vm._i(
                                                  _vm.demandDetail.OverseasWork,
                                                  null
                                                ) > -1
                                              : _vm.demandDetail.OverseasWork,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.demandDetail.OverseasWork,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "OverseasWork",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "OverseasWork",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "OverseasWork",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" 需要 "),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        !_vm.demandDetail.OverseasWork
                                          ? "否"
                                          : "是"
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("管理責任")]),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", [
                                  _c("div", { staticClass: "form-inline" }, [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.demandDetail
                                                  .ManagementResponsibility,
                                              expression:
                                                "demandDetail.ManagementResponsibility",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.demandDetail
                                                .ManagementResponsibility
                                            )
                                              ? _vm._i(
                                                  _vm.demandDetail
                                                    .ManagementResponsibility,
                                                  null
                                                ) > -1
                                              : _vm.demandDetail
                                                  .ManagementResponsibility,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.demandDetail
                                                    .ManagementResponsibility,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "ManagementResponsibility",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "ManagementResponsibility",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "ManagementResponsibility",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          " 需要 (若勾選，請填寫管理人數) "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm.demandDetail.ManagementResponsibility
                                    ? _c(
                                        "div",
                                        { staticClass: "form-inline" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "min_value:1|required",
                                              name: "管理人數",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.demandDetail
                                                                .ManagementNumber,
                                                            expression:
                                                              "demandDetail.ManagementNumber",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          type: "number",
                                                          min: "1",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.demandDetail
                                                              .ManagementNumber,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.demandDetail,
                                                              "ManagementNumber",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _c("div", [
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  _vm.demandDetail.ManagementResponsibility
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.demandDetail.ManagementNumber
                                            ) +
                                            " 人 "
                                        ),
                                      ])
                                    : _c("span", [_vm._v("無")]),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [_vm._v("輪班")]),
                          ]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-check form-check-inline",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.demandDetail.Shift,
                                              expression: "demandDetail.Shift",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.demandDetail.Shift
                                            )
                                              ? _vm._i(
                                                  _vm.demandDetail.Shift,
                                                  null
                                                ) > -1
                                              : _vm.demandDetail.Shift,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.demandDetail.Shift,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "Shift",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "Shift",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "Shift",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" 需要 "),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        !_vm.demandDetail.Shift ? "否" : "是"
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("班別")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  _vm._l(_vm.newWorkingHours, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.WorkShiftTypeGuid,
                                        staticClass: "form-check",
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "form-check-label" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.demandDetail
                                                      .ManpowerDemandWorkShiftType,
                                                  expression:
                                                    "demandDetail.ManpowerDemandWorkShiftType",
                                                },
                                              ],
                                              staticClass: "form-check-input",
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: item,
                                                checked: Array.isArray(
                                                  _vm.demandDetail
                                                    .ManpowerDemandWorkShiftType
                                                )
                                                  ? _vm._i(
                                                      _vm.demandDetail
                                                        .ManpowerDemandWorkShiftType,
                                                      item
                                                    ) > -1
                                                  : _vm.demandDetail
                                                      .ManpowerDemandWorkShiftType,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.demandDetail
                                                        .ManpowerDemandWorkShiftType,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = item,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.demandDetail,
                                                          "ManpowerDemandWorkShiftType",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.demandDetail,
                                                          "ManpowerDemandWorkShiftType",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "ManpowerDemandWorkShiftType",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(item.WorkShiftType) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                item.WorkShiftTypeDescription,
                                              expression:
                                                "item.WorkShiftTypeDescription",
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "請填寫詳細時段或排班資訊",
                                          },
                                          domProps: {
                                            value:
                                              item.WorkShiftTypeDescription,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "WorkShiftTypeDescription",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.workingHoursStatus
                                      ? _c("span", [_vm._v("不拘")])
                                      : _vm._l(
                                          _vm.showWorkShiftType,
                                          function (item) {
                                            return _c(
                                              "span",
                                              { key: item.WorkShiftTypeGuid },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(item.WorkShiftType)
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "，時段：" +
                                                    _vm._s(
                                                      item.WorkShiftTypeDescription
                                                    ) +
                                                    " "
                                                ),
                                                _c("br"),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("工作地點")])]
                          ),
                          _vm.is_editing
                            ? _c(
                                "td",
                                { attrs: { colspan: "3" } },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("multiselect", {
                                                attrs: {
                                                  options: _vm.workplaceList,
                                                  "close-on-select": false,
                                                  multiple: true,
                                                  selectLabel: "",
                                                  selectedLabel: "",
                                                  deselectLabel: "",
                                                  "track-by": "WorkPlaceGuid",
                                                  label: "WorkPlace",
                                                  placeholder: "請選擇",
                                                },
                                                model: {
                                                  value:
                                                    _vm.demandDetail
                                                      .ManpowerDemandWorkPlace,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.demandDetail,
                                                      "ManpowerDemandWorkPlace",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "demandDetail.ManpowerDemandWorkPlace",
                                                },
                                              }),
                                              errors[0] && !_vm.is_composing
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger ml-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.is_editing
                            ? _c(
                                "td",
                                { attrs: { colspan: "3" } },
                                _vm._l(
                                  _vm.demandDetail.ManpowerDemandWorkPlace,
                                  function (item, index) {
                                    return _c(
                                      "span",
                                      { key: item.WorkPlaceGuid },
                                      [
                                        index > 0
                                          ? _c("span", [_vm._v("、")])
                                          : _vm._e(),
                                        _vm._v(_vm._s(item.WorkPlace) + " "),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("工作內容")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: "required",
                                        name: "工作內容",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.demandDetail
                                                          .WorkContent,
                                                      expression:
                                                        "demandDetail.WorkContent",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { rows: "8" },
                                                  domProps: {
                                                    value:
                                                      _vm.demandDetail
                                                        .WorkContent,
                                                  },
                                                  on: {
                                                    compositionstart: function (
                                                      $event
                                                    ) {
                                                      _vm.is_composing = true
                                                    },
                                                    compositionend: function (
                                                      $event
                                                    ) {
                                                      _vm.is_composing = false
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "WorkContent",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                errors[0] && !_vm.is_composing
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.demandDetail.WorkContent)
                                    ),
                                  ]),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("說明")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.demandDetail.Description,
                                      expression: "demandDetail.Description",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "5" },
                                  domProps: {
                                    value: _vm.demandDetail.Description,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.demandDetail,
                                        "Description",
                                        $event.target.value
                                      )
                                    },
                                  },
                                })
                              : _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.demandDetail.Description)
                                    ),
                                  ]),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("薪資類型")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("v-select", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    options: _vm.salaryTypeList,
                                                    label: "Name",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value: _vm.salaryTypeValue,
                                                    callback: function ($$v) {
                                                      _vm.salaryTypeValue = $$v
                                                    },
                                                    expression:
                                                      "salaryTypeValue",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm.salaryTypeValue &&
                                    _vm.salaryTypeValue.Code === "other"
                                      ? _c("ValidationProvider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.demandDetail
                                                              .SalaryTypeDescription,
                                                          expression:
                                                            "demandDetail.SalaryTypeDescription",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        "margin-top": "5px",
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          "請填寫薪資類型",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.demandDetail
                                                            .SalaryTypeDescription,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.demandDetail,
                                                            "SalaryTypeDescription",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.demandDetail.SalaryTypeDescription
                                          ? _vm.demandDetail
                                              .SalaryTypeDescription
                                          : _vm.demandDetail.SalaryType
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("薪資待遇")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            tag: "section",
                                            name: "薪資待遇(低)",
                                            rules: {
                                              regex: new RegExp(/^([0-9,]+)$/),
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.trim",
                                                          value:
                                                            _vm.demandDetail
                                                              .SalaryLow,
                                                          expression:
                                                            "demandDetail.SalaryLow",
                                                          modifiers: {
                                                            trim: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control text-right",
                                                      attrs: { type: "text" },
                                                      domProps: {
                                                        value:
                                                          _vm.demandDetail
                                                            .SalaryLow,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.demandDetail,
                                                            "SalaryLow",
                                                            $event.target.value.trim()
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" ~ "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            tag: "section",
                                            name: "薪資待遇(高)",
                                            rules: {
                                              regex: new RegExp(/^([0-9,]+)$/),
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.trim",
                                                          value:
                                                            _vm.demandDetail
                                                              .SalaryHigh,
                                                          expression:
                                                            "demandDetail.SalaryHigh",
                                                          modifiers: {
                                                            trim: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control text-right",
                                                      attrs: { type: "text" },
                                                      domProps: {
                                                        value:
                                                          _vm.demandDetail
                                                            .SalaryHigh,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.demandDetail,
                                                            "SalaryHigh",
                                                            $event.target.value.trim()
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.demandDetail.SalaryLow) +
                                      " " +
                                      _vm._s(
                                        _vm.demandDetail.SalaryHigh
                                          ? "~" + _vm.demandDetail.SalaryHigh
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _vm.demandDetail.ResumeType === "DL"
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "1" },
                                },
                                [_c("span", [_vm._v("預設職稱")])]
                              ),
                              _c("td", { attrs: { colspan: "3" } }, [
                                _vm.is_editing
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: { placeholder: "請選擇" },
                                            model: {
                                              value:
                                                _vm.demandDetail
                                                  .AppointmentDefaultPosition,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "AppointmentDefaultPosition",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "demandDetail.AppointmentDefaultPosition",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "生產助理員",
                                                value: "生產助理員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "助理",
                                                value: "助理",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "技術助理員",
                                                value: "技術助理員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "技術員",
                                                value: "技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "高級技術員",
                                                value: "高級技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "事務員",
                                                value: "事務員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "資深技術員",
                                                value: "資深技術員",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "組長",
                                                value: "組長",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "儲備組長",
                                                value: "儲備組長",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "工讀生",
                                                value: "工讀生",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "實習生",
                                                value: "實習生",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "按摩師",
                                                value: "按摩師",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.demandDetail
                                              .AppointmentDefaultPosition
                                          ) +
                                          " "
                                      ),
                                    ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.demandDetail.ResumeType === "DL"
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-right",
                                  attrs: { colspan: "1" },
                                },
                                [_c("span", [_vm._v("預設職等")])]
                              ),
                              _c("td", { attrs: { colspan: "3" } }, [
                                _vm.is_editing
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: { placeholder: "請選擇" },
                                            model: {
                                              value:
                                                _vm.demandDetail
                                                  .AppointmentDefaultRank,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.demandDetail,
                                                  "AppointmentDefaultRank",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "demandDetail.AppointmentDefaultRank",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: { label: "1", value: "1" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "2", value: "2" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "2.1",
                                                value: "2.1",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "2.2",
                                                value: "2.2",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "3", value: "3" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "4", value: "4" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "5", value: "5" },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "6", value: "6" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "6.3",
                                                value: "6.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "7", value: "7" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "7.3",
                                                value: "7.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "8", value: "8" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "8.3",
                                                value: "8.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: { label: "9", value: "9" },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "9.3",
                                                value: "9.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10",
                                                value: "10",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.3",
                                                value: "10.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.5",
                                                value: "10.5",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "10.7",
                                                value: "10.7",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11",
                                                value: "11",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11.3",
                                                value: "11.3",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "11.5",
                                                value: "11.5",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "12",
                                                value: "12",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "13",
                                                value: "13",
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label: "13.3",
                                                value: "13.3",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.demandDetail
                                              .AppointmentDefaultRank
                                          ) +
                                          " "
                                      ),
                                    ]),
                              ]),
                            ])
                          : _vm._e(),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("預設薪資")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "預設薪資",
                                        rules: {
                                          regex: new RegExp(/^([0-9,]+)$/),
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.demandDetail
                                                          .AppointmentDefaultSalary,
                                                      expression:
                                                        "demandDetail.AppointmentDefaultSalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control text-right",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.demandDetail
                                                        .AppointmentDefaultSalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "AppointmentDefaultSalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                                errors[0] && !_vm.is_composing
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.demandDetail
                                          .AppointmentDefaultSalary
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("職務聯絡人")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      staticClass: "w-100",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("multiselect", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    options:
                                                      _vm.supervisorOptions,
                                                    label: "Name",
                                                    placeholder: "請選擇",
                                                    "track-by": "Email",
                                                    selectLabel: "",
                                                    selectedLabel: "",
                                                    deselectLabel: "",
                                                    taggable: true,
                                                  },
                                                  on: {
                                                    tag: _vm.addPositionContactorTag,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.demandDetail
                                                        .PositionContactor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "PositionContactor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "demandDetail.PositionContactor",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.demandDetail.PositionContactor
                                          ? _vm.demandDetail.PositionContactor
                                              .Name
                                          : null
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("聯絡人Email")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("ValidationProvider", {
                                      staticClass: "w-100",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.demandDetail
                                                          .PositionContactorEmail,
                                                      expression:
                                                        "demandDetail.PositionContactorEmail",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control w-100",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value:
                                                      _vm.demandDetail
                                                        .PositionContactorEmail,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "PositionContactorEmail",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.demandDetail.PositionContactorEmail
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("工作經歷")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .WorkExperienceWhatever,
                                                expression:
                                                  "demandDetail.WorkExperienceWhatever",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.demandDetail
                                                  .WorkExperienceWhatever
                                              )
                                                ? _vm._i(
                                                    _vm.demandDetail
                                                      .WorkExperienceWhatever,
                                                    null
                                                  ) > -1
                                                : _vm.demandDetail
                                                    .WorkExperienceWhatever,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.demandDetail
                                                      .WorkExperienceWhatever,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "WorkExperienceWhatever",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "WorkExperienceWhatever",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.demandDetail,
                                                    "WorkExperienceWhatever",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            " 不拘 (若不勾選，請填寫年資) "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  !_vm.demandDetail.WorkExperienceWhatever
                                    ? _c(
                                        "div",
                                        { staticClass: "form-inline" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              name: "年資",
                                              rules: "min_value:1|required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.number",
                                                            value:
                                                              _vm.demandDetail
                                                                .WorkExperience,
                                                            expression:
                                                              "demandDetail.WorkExperience",
                                                            modifiers: {
                                                              number: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control w-100",
                                                        attrs: {
                                                          type: "number",
                                                          min: "1",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.demandDetail
                                                              .WorkExperience,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.demandDetail,
                                                              "WorkExperience",
                                                              _vm._n(
                                                                $event.target
                                                                  .value
                                                              )
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      errors[0]
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  _vm.demandDetail.WorkExperienceWhatever
                                    ? _c("span", [_vm._v("不拘")])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.demandDetail.WorkExperience
                                          ) + " 年"
                                        ),
                                      ]),
                                ]),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("學歷")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-check form-check-inline",
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.demandDetail
                                                    .EducationDemandWhatever,
                                                expression:
                                                  "demandDetail.EducationDemandWhatever",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.demandDetail
                                                  .EducationDemandWhatever
                                              )
                                                ? _vm._i(
                                                    _vm.demandDetail
                                                      .EducationDemandWhatever,
                                                    null
                                                  ) > -1
                                                : _vm.demandDetail
                                                    .EducationDemandWhatever,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.demandDetail
                                                      .EducationDemandWhatever,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "EducationDemandWhatever",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.demandDetail,
                                                        "EducationDemandWhatever",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.demandDetail,
                                                    "EducationDemandWhatever",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" 不拘 "),
                                        ]
                                      ),
                                    ]
                                  ),
                                  !_vm.demandDetail.EducationDemandWhatever
                                    ? _c(
                                        "div",
                                        [
                                          _c("ValidationProvider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ failed }) {
                                                    return [
                                                      _vm._l(
                                                        _vm.educationDegree,
                                                        function (item) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: item.Guid,
                                                              staticClass:
                                                                "form-check form-check-inline",
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "form-check-label",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .demandDetail
                                                                              .ManpowerDemandEducationDegree,
                                                                          expression:
                                                                            "\n                              demandDetail.ManpowerDemandEducationDegree\n                            ",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-check-input",
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm
                                                                            .demandDetail
                                                                            .ManpowerDemandEducationDegree
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm
                                                                                .demandDetail
                                                                                .ManpowerDemandEducationDegree,
                                                                              item
                                                                            ) >
                                                                            -1
                                                                          : _vm
                                                                              .demandDetail
                                                                              .ManpowerDemandEducationDegree,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm
                                                                                .demandDetail
                                                                                .ManpowerDemandEducationDegree,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                item,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  _vm.demandDetail,
                                                                                  "ManpowerDemandEducationDegree",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  _vm.demandDetail,
                                                                                  "ManpowerDemandEducationDegree",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              _vm.demandDetail,
                                                                              "ManpowerDemandEducationDegree",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.EducationDegree
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      failed
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-danger ml-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 請選擇學歷 "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _vm.demandDetail.EducationDemandWhatever
                                      ? _c("span", [_vm._v(" 不拘 ")])
                                      : _vm._l(
                                          _vm.demandDetail
                                            .ManpowerDemandEducationDegree,
                                          function (item, index) {
                                            return _c(
                                              "span",
                                              { key: item.EducationDegreeGuid },
                                              [
                                                index > 0
                                                  ? _c("span", [_vm._v("、")])
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.EducationDegree
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("科系")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.demandDetail
                                        .ManpowerDemandSchoolDepartment,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "margin-bottom": "20px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "language-title" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.SchoolDepartmentType
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteItem(
                                                          index,
                                                          "Education"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("eva-icon", {
                                                      attrs: {
                                                        fill: "#FFF",
                                                        name: "trash-2-outline",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "12px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.SchoolDepartment
                                                            ? item.SchoolDepartment
                                                            : null
                                                        ) +
                                                        " "
                                                    ),
                                                    item.SchoolDepartmentDescription
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " ｜科系描述：" +
                                                              _vm._s(
                                                                item.SchoolDepartmentDescription
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _vm.addMajor
                                          ? _c("AddMajor", {
                                              on: {
                                                addMajor: _vm.saveItem,
                                                addCancel: function ($event) {
                                                  return _vm.cancelItem(
                                                    "Education"
                                                  )
                                                },
                                              },
                                            })
                                          : _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addItem(
                                                      "Education"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-plus",
                                                }),
                                                _vm._v(" 新增科系 "),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.demandDetail.SchoolDepartmentWhatever
                                      ? _c("span", [_vm._v(" 不拘 ")])
                                      : _vm._l(
                                          _vm.demandDetail
                                            .ManpowerDemandSchoolDepartment,
                                          function (item, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "language-title",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.SchoolDepartmentType
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "h6",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "12px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.SchoolDepartment
                                                          ? item.SchoolDepartment
                                                          : null
                                                      ) +
                                                      " "
                                                  ),
                                                  item.SchoolDepartmentDescription
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " ｜科系描述：" +
                                                            _vm._s(
                                                              item.SchoolDepartmentDescription
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("外語")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.demandDetail.ManpowerDemandLanguage,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "margin-bottom": "20px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "language-title" },
                                              [_vm._v(_vm._s(item.Language))]
                                            ),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "12px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "聽：" +
                                                        _vm._s(item.Listen)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("｜ "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "說：" +
                                                        _vm._s(item.Speak)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("｜ "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "讀：" + _vm._s(item.Read)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("｜ "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "寫：" +
                                                        _vm._s(item.Write)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteItem(
                                                          index,
                                                          "Language"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("eva-icon", {
                                                      attrs: {
                                                        fill: "#FFF",
                                                        name: "trash-2-outline",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.addLanguage
                                      ? _c("AddLanguage", {
                                          on: {
                                            addLanguage: _vm.saveItem,
                                            addCancel: function ($event) {
                                              return _vm.cancelItem("Language")
                                            },
                                          },
                                        })
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem("Language")
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-plus",
                                            }),
                                            _vm._v(" 新增外語 "),
                                          ]
                                        ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.languageStatus
                                      ? _c("span", [_vm._v("不拘")])
                                      : _vm._l(
                                          _vm.demandDetail
                                            .ManpowerDemandLanguage,
                                          function (item, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "language-title",
                                                },
                                                [_vm._v(_vm._s(item.Language))]
                                              ),
                                              _c(
                                                "h6",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "12px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "language-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "聽：" +
                                                          _vm._s(item.Listen)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v("｜ "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "language-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "說：" +
                                                          _vm._s(item.Speak)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v("｜ "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "language-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "讀：" +
                                                          _vm._s(item.Read)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v("｜ "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "language-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "寫：" +
                                                          _vm._s(item.Write)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("方言")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.demandDetail.ManpowerDemandDialect,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "margin-bottom": "20px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "language-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.DialectDescription
                                                      ? item.DialectDescription
                                                      : item.Dialect
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "12px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "language-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 程度：" +
                                                        _vm._s(item.Degree) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteItem(
                                                          index,
                                                          "Dialect"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("eva-icon", {
                                                      attrs: {
                                                        fill: "#FFF",
                                                        name: "trash-2-outline",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.addDialect
                                      ? _c("AddDialect", {
                                          on: {
                                            addDialect: _vm.saveItem,
                                            addCancel: function ($event) {
                                              return _vm.cancelItem("Dialect")
                                            },
                                          },
                                        })
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem("Dialect")
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-plus",
                                            }),
                                            _vm._v(" 新增方言 "),
                                          ]
                                        ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.dialectStatus
                                      ? _c("span", [_vm._v("不拘")])
                                      : _vm._l(
                                          _vm.demandDetail
                                            .ManpowerDemandDialect,
                                          function (item, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "language-title",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.DialectDescription
                                                        ? item.DialectDescription
                                                        : item.Dialect
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(
                                                  "程度：" + _vm._s(item.Degree)
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("駕照")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c(
                                  "div",
                                  [
                                    _c("el-cascader", {
                                      staticClass: "w-100",
                                      attrs: {
                                        options: _vm.driverLicenses,
                                        clearable: "",
                                        filterable: "",
                                        props: _vm.props,
                                        "show-all-levels": false,
                                      },
                                      on: { change: _vm.driverLicensesChange },
                                      model: {
                                        value: _vm.manpowerDemandDriverLicense,
                                        callback: function ($$v) {
                                          _vm.manpowerDemandDriverLicense = $$v
                                        },
                                        expression:
                                          "manpowerDemandDriverLicense",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.driverLicenseStatus
                                      ? _c("span", [_vm._v("不拘")])
                                      : _vm._l(
                                          _vm.demandDetail
                                            .ManpowerDemandDriverLicense,
                                          function (item, index) {
                                            return _c("span", { key: index }, [
                                              index > 0
                                                ? _c("span", [_vm._v("、")])
                                                : _vm._e(),
                                              _vm._v(
                                                _vm._s(item.DriverLicense) + " "
                                              ),
                                            ])
                                          }
                                        ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("證照")])]
                          ),
                          _c(
                            "td",
                            { attrs: { colspan: "3" } },
                            [
                              _vm.is_editing
                                ? [
                                    _c("el-cascader", {
                                      staticClass: "w-100",
                                      attrs: {
                                        options: _vm.certifications,
                                        clearable: "",
                                        filterable: "",
                                        props: _vm.props,
                                        "show-all-levels": false,
                                        "filter-method":
                                          _vm.certificationsFilter,
                                      },
                                      on: { change: _vm.certificationsChange },
                                      model: {
                                        value: _vm.chooseCertifications,
                                        callback: function ($$v) {
                                          _vm.chooseCertifications = $$v
                                        },
                                        expression: "chooseCertifications",
                                      },
                                    }),
                                    _vm.certificateOther
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            tag: "section",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.certificateDescription,
                                                          expression:
                                                            "certificateDescription",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control mt-2",
                                                      attrs: { rows: "5" },
                                                      domProps: {
                                                        value:
                                                          _vm.certificateDescription,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.certificateDescription =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      : _vm._e(),
                                  ]
                                : _c(
                                    "div",
                                    _vm._l(
                                      Object.keys(_vm.showCertifications),
                                      function (category) {
                                        return _c(
                                          "div",
                                          { key: category },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mr-2" },
                                              [_vm._v(_vm._s(category))]
                                            ),
                                            _vm._l(
                                              _vm.showCertifications[category],
                                              function (item, index) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.CertificateDescription
                                                            ? item.CertificateDescription
                                                            : item.Certificate
                                                        ) +
                                                        " "
                                                    ),
                                                    index !==
                                                    _vm.showCertifications[
                                                      category
                                                    ].length -
                                                      1
                                                      ? _c("span", [
                                                          _vm._v("、"),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c("br"),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                            ],
                            2
                          ),
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "1" },
                            },
                            [_c("span", [_vm._v("其他條件")])]
                          ),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm.is_editing
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.demandDetail.OtherConditions,
                                      expression:
                                        "demandDetail.OtherConditions",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { maxlength: "500", rows: "3" },
                                  domProps: {
                                    value: _vm.demandDetail.OtherConditions,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.demandDetail,
                                        "OtherConditions",
                                        $event.target.value
                                      )
                                    },
                                  },
                                })
                              : _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.demandDetail.OtherConditions)
                                    ),
                                  ]),
                                ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }